import { Input, InputProps } from '@chakra-ui/react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import {
  CURRENCY_TO_NUMBER,
  NUMBER_TO_CURRENCY,
} from '@/utils/helpers/Currency'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    InputProps {}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    ...rest
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => (
        <Input
          onChange={(e) => {
            onChange(CURRENCY_TO_NUMBER(e.target.value))
          }}
          value={NUMBER_TO_CURRENCY(value)}
          {...rest}
        />
      )}
    />
  )
}
